import { ConfirmButtons, Modal } from "src/components/ui"


export const DeleteModal  = ({ open, onSubmit, closeModal }) => {
return (
    <Modal width={530} open={open} title={"Are you sure you want to delete campaign?"} onCancel={closeModal}>This can't be undone.<br /><br />
    <ConfirmButtons leftButtonTitle={"Back"} rightButtonTitle={"Delete"} handleSubmit={onSubmit} onCancel={closeModal} />
    </Modal>)
}